<template>
  <div>
    <TopBar></TopBar>
    <LeftToolbar></LeftToolbar>
    <v-main>
      <div class="view">
        <div class="main-box">
          <router-view :key="$route.fullPath + reloadKey"/>
        </div>
      </div>
    </v-main>
    <Loading></Loading>
    <Notifications></Notifications>
  </div>
</template>

<script>
import Loading from "@/components/utils/Loading";
import Notifications from "@/components/utils/Notifications";
import LeftToolbar from "@/components/layout/LeftToolbar.vue";
import TopBar from "@/components/layout/TopBar.vue";
import { onStateChange } from "@/services/pushBridge";
export default {
  name: "Admin",
  components: {TopBar, LeftToolbar, Notifications, Loading},
  data() {
    return {
      reloadKey: '',
      unsubscribePushState: null
    };
  },
  created() {
    this.$root.$on('forceReload', () => {
      this.reloadKey = `-${Date.now()}`;
    });
  },
  mounted() {
    // Admin è montato solo da utenti loggati: registra il device per le push
    // native e resta in ascolto del bridge (copre il refresh del token FCM).
    this.$store.dispatch('pushNotifications/registerDevice');
    this.unsubscribePushState = onStateChange(() => {
      this.$store.dispatch('pushNotifications/registerDevice');
    });
    this.markOpenedNotificationAsRead();
  },
  beforeDestroy() {
    if (this.unsubscribePushState) {
      this.unsubscribePushState();
      this.unsubscribePushState = null;
    }
  },
  methods: {
    // Tap su una push: l'app appende notification_id alla query REALE
    // (prima dell'hash, /?notification_id=x#/path) quindi va letto da
    // location.search; per sicurezza copre anche la query dentro l'hash
    // (#/path?notification_id=x) che vue-router espone in $route.query.
    async markOpenedNotificationAsRead() {
      let notificationId = null;

      const params = new URLSearchParams(window.location.search);
      if (params.get('notification_id')) {
        notificationId = params.get('notification_id');
        params.delete('notification_id');
        const query = params.toString();
        const cleanUrl = `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`;
        window.history.replaceState(null, '', cleanUrl);
      } else if (this.$route.query.notification_id) {
        notificationId = this.$route.query.notification_id;
        const { notification_id, ...rest } = this.$route.query;
        this.$router.replace({ query: rest }).catch(() => {});
      }

      if (!notificationId) {
        return;
      }

      const result = await this.$store.dispatch('pushNotifications/read', { id: notificationId });
      // eslint-disable-next-line no-console
      console.log('[push] mark-as-read', notificationId, result);
      this.$root.$emit('refreshNotifications');
    }
  }
}
</script>

<style scoped>
.view{
  padding: 15px;
  margin-top: 4%;
}
.main-box{
  padding: 10px;
  border: 1px solid #e4e4e4
}

@media only screen and (max-width: 767px) {
  .view{
    margin-top: 12%;
  }

  .main-box{
    overflow-x: auto;
    overflow-y: hidden;
  }
}
</style>